
export class HomeConsoleClasses {

    static readonly logoBg = "ic3HomeConsole-logoBg";

    static readonly logoFg = "ic3HomeConsole-logoFg";

    static readonly logoBgSvg = "ic3HomeConsole-logoBgSvg";

    static readonly logoFgSvg = "ic3HomeConsole-logoFgSvg";

    static readonly cardTextureAdmin = "ic3HomeConsole-cardTextureAdmin";

    static readonly backgroundOthers = "ic3HomeConsole-backgroundOthers";

    static readonly textureLeft = "ic3HomeConsole-textureLeft";

    static readonly textureRight = "ic3HomeConsole-textureRight";

    static readonly customLayout = "ic3HomeConsole-customLayout";

    static readonly caption = "ic3HomeConsole-caption";

    static readonly appName = "ic3HomeConsole-appName";

    static readonly appNameRecent = "ic3HomeConsole-appName-recent";

    static readonly slogan = "ic3HomeConsole-slogan";

}

export declare type HomeConsoleClassKey = keyof HomeConsoleClasses;
